import Service, { LoanService, AuthService } from '@/utils/service'
export const getCardStatus = () => {
    return new LoanService({
        url: '/loan/app/pmt/v4/profile',
        method: 'get'
    })
}
export const sendSmsForValidBank = (params = {
    applyId: 0,
    cardId: ''
}) => {
    return new LoanService({
        url: '/loan/app/pmt/v4/card/verify',
        method: 'get',
        data: {
            applyId: params.applyId,
            cardId: params.cardId
        }
    })
}
export const getSupportBankList = (params = {
    applyId: 0
}) => {
    return new LoanService({
        url: '/loan/app/pmt/v4/banks',
        method: 'get',
        data: {
            applyId: params.applyId || 0
        }
    })
}
export const cardbin = (params = {
    cardNo: ''
}) => {
    return new LoanService({
        url: '/loan/app/pmt/v4/cardbin',
        method: 'get',
        data: {
            cardNo: params.cardNo
        },
        needLoading: false
    })
}
export const sendSmsForBank = (params = {
    cardNo: '',
    bankNo: '',
    mobile: ''
}) => {
    return new LoanService({
        url: '/loan/app/pmt/v4/card/bind',
        method: 'get',
        data: {
            cardNo: params.cardNo,
            bankNo: params.bankNo,
            mobile: params.mobile
        }
    })
}
export const bindBankCardForApply = (params = {
    applyId: 0,
    cardNo: '',
    bankNo: '',
    mobile: '',
    seqNumber: '',
    smsCode: '',
    verifyCode: '',
    channel: ''
}) => {
    params.bankVerify = true;
    return new LoanService({
        url: '/loan/app/pmt/v4/card/bind',
        method: 'post',
        data: params
    })
}
export const bindBankCard = (params = {
    cardNo: '',
    bankNo: '',
    mobile: '',
    seqNumber: '',
    smsCode: '',
    verifyCode: '',
    channel: ''
}) => {
    params.bankVerify = false;
    return new LoanService({
        url: '/loan/app/pmt/v4/card/bind',
        method: 'post',
        data: params
    })
}

export const validBankCardForApply = (params = {
    applyId: 0,
    cardId: '',
    smsCode: ''
}) => {
    return new LoanService({
        url: '/loan/app/pmt/v4/card/verify',
        method: 'post',
        data: params
    })
}

export const getCmbcUrl = (params = {
    realName: '',
    idCard: '',
    source: ''
}) => {
    return new AuthService({
        url: '/api/user/cmbc/url',
        method: 'post',
        data: {
            ...params,
            source: params.source || 'h5_wallet'
        }
    })
}
export const getWithdrawCards = () => {
    return new Service({
        url: '/jimubox/bank/myBankCards',
        method: 'get'
    })
}
export const getRepayBankCards = () => {
    return new LoanService({
        url: '/loan/app/pmt/v4/profile',
        method: 'get'
    })
}
export const bindCard = (redirectUrl, setDefaultCard) => {
    return new AuthService({
        url: '/api/user/card/bind',
        method: 'get',
        data: {
            redirectUrl: redirectUrl || '',
            setDefaultCard: setDefaultCard || false,
            productId: 'DM-QBXJ'
        }
    })
}
export const bindCardV2 = (params = {
    userId: 0,
    applyId: 0,
    redirectUrl: '',
    app: 0,
    setDefaultCard: false,
    skin: 'default',
    productId: 'DM-QBXJ'
}) => {
    return new AuthService({
        url: '/api/user/card/bind/v2',
        method: 'get',
        data: params
    })
}
export const setAutoFlag = (cardId) => {
    return new LoanService({
        url: '/loan/app/pmt/v4/withhold/card',
        method: 'post',
        data: {
            cardId: cardId
        }
    })
}
export const stepIdCard = (idCard) => {
    return new LoanService({
        url: '/loan/app/pmt/v4/withhold/card',
        method: 'post',
        data: {
            cardId: idCard
        }
    })
}

// 获取公共绑卡url
export const getPmtUrl = (params = {
    userId: 0,
    callback: '',
    callbackString: 0, // 此字段传applyId
    source: 'dumiao',
    app: 1,
    skin: '',
    userIdKey: 0, // access_key
    setDefaultCard: false,
}) => {
    return new LoanService({
        url: '/loan/pmt/v1/redirect/valid',
        method: 'get',
        data: params
    })
}